<template lang="pug">
ul.menuList
  MenuListLink(
    :text="'行程紀錄'"
    @click="toUrl('/ReservationRecords')"
  )
    template(v-slot:icon)
      reservationIcon.menuList__icon.menuList__icon--reservation
  <!-- MenuListLink( -->
  <!--   :text="'付款設定'" -->
  <!--   @click="toUrl('/PaymentSetup')" -->
  <!-- ) -->
  <!--   template(v-slot:icon) -->
  <!--     paymentIcon.menuList__icon.menuList__icon--payment -->
  MenuListLink(
    :text="'最愛司機設定'"
    @click="toUrl('/FavoriteDrivers')"
  )
    template(v-slot:icon)
      favoriteIcon.menuList__icon.menuList__icon--favorite
  MenuListLink(
    :text="'黑名單司機設定'"
    @click="toUrl('/ForbiddenDrivers')"
  )
    template(v-slot:icon)
      forbbidenIcon.menuList__icon.menuList__icon--forbbiden
  MenuListLink(
    :text="'檢視公告'"
    @click="showAnnouncement"
  )
    template(v-slot:icon)
      announcementIcon.menuList__icon.menuList__icon--announcement

  //- 只在 staging 環境顯示的 localStorage 測試功能
  MenuListLink(
    v-if="isStagingEnvironment"
    :text="'調試工具'"
    @click="showDebugConsole"
  )
    template(v-slot:icon)
      debugIcon.menuList__icon.menuList__icon--debug

</template>

<script>
import MenuListLink from './MenuListLink'
import reservationIcon from '@/assets/images/list-alt-24-px.svg'
import historyIcon from '@/assets/images/history-24-px-2.svg'
import paymentIcon from '@/assets/images/payment-24-px.svg'
import favoriteIcon from '@/assets/images/favorite-24-px.svg'
import forbbidenIcon from '@/assets/images/block-24-px.svg'
import debugIcon from '@/assets/images/svg/tools-svgrepo-com.svg'
import announcementIcon from '@/assets/images/list-alt-24-px.svg'

export default {
  name: 'MenuList',
  components: {
    MenuListLink,
    reservationIcon,
    historyIcon,
    paymentIcon,
    favoriteIcon,
    forbbidenIcon,
    debugIcon,
    announcementIcon,
  },
  computed: {
    // 判斷是否為 staging 環境
    isStagingEnvironment() {
      // 根據專案的環境判斷邏輯，當 NODE_ENV 為空字串時表示開發環境
      // 這裡我們假設 staging 環境的判斷條件
      return (
        process.env.NODE_ENV === 'staging' ||
        process.env.NODE_ENV === 'development' ||
        window.location.hostname.includes('staging') ||
        window.location.hostname.includes('dev')
      )
    },
  },
  methods: {
    toUrl(url) {
      this.$emit('routeChanged', url)
    },
    showAnnouncement() {
      // 發送事件通知顯示公告
      this.$root.$emit('showAnnouncement')
      // 關閉選單（通過發送特殊事件）
      this.$emit('closeMenu')
    },
    // 啟動 vconsole debug 視窗的方法
    showDebugConsole() {
      try {
        // 檢查是否已經有 vConsole 實例
        if (window.vConsole) {
          // 如果已經存在，則隱藏 vConsole 並移除實例
          window.vConsole.hide()
          window.vConsole.destroy()
          window.vConsole = null
          console.log('vConsole 已關閉')
        } else {
          // 如果不存在，則創建新的 vConsole 實例
          if (typeof VConsole !== 'undefined') {
            window.vConsole = new VConsole()
            console.log('vConsole 已啟動')
            console.log('目前環境 =', process.env.NODE_ENV)

            // 在 vConsole 中顯示一些有用的 debug 資訊
            this.logDebugInfo()
            window.vConsole.show()
          } else {
            console.error(
              'VConsole 未載入，請確認 index.html 中已引入 vconsole'
            )
            alert('VConsole 未載入，請確認已正確引入 vconsole 函式庫')
          }
        }
      } catch (error) {
        console.error('啟動 vConsole 時發生錯誤：', error)
        alert('啟動 vConsole 時發生錯誤，請查看 console 了解詳細資訊')
      }
    },

    // 在 vConsole 中記錄 debug 資訊
    logDebugInfo() {
      // 記錄 localStorage 內容
      const localStorageData = {}
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key) {
          try {
            const value = localStorage.getItem(key)
            localStorageData[key] = value
          } catch (error) {
            localStorageData[key] = '無法讀取此項目'
          }
        }
      }
      console.log('🔍 LocalStorage 內容：', localStorageData)

      // 記錄當前頁面資訊
      console.log('📱 當前頁面資訊：', {
        url: window.location.href,
        userAgent: navigator.userAgent,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
        },
      })

      // 記錄 Vue 應用資訊
      console.log('⚡ Vue 應用資訊：', {
        version: this.$root.$options.version || 'Vue 2',
        route: this.$route?.path,
        store: this.$store?.state,
      })

      // 記錄環境資訊
      console.log('🌍 環境資訊：', {
        nodeEnv: process.env.NODE_ENV,
        hostname: window.location.hostname,
        protocol: window.location.protocol,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.menuList {
  margin: 0;
  padding: 0;
  padding-top: 12px;
}

.menuList__icon--debug {
  width: 24px;
  height: 24px;
}
</style>
